// Services
import { reportColumns } from "../../../Constants/reportColumns";
import { reportFields } from "../../../Constants/reportFields";
import { getLocationCoordinates } from "../../../Services/locations.service";
import {
  toDateString,
  toDateTime,
  toDistanceFormat,
  toSpeedFormat,
} from "../../../Services/string.service";

import { useEffect } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import "./styles.css";

import { useTranslation } from "react-i18next";

export default function GridReport(props) {
const { t } = useTranslation();

  useEffect(() => {
    (async () => {
      try {
        props.gridData = null;
      } catch (error) {
        console.log(error);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.page]);

  const fields = reportFields[props.pageGrid];
  const columns = reportColumns(t)[props.pageGrid];
  const isGeneratedAtField = (field) => `${field || ""}`.toLowerCase() === "generatedat";

  const renderData = (value, item, field, fieldsIndex) => {
    if (!field) return;

    if (field.toLowerCase().includes("plate")) {
      return (
        <td key={fieldsIndex}>
          <div class="tooltipReport">
            <span>{value} </span>
            <span class="tooltipReportText">{item.licensePlateType || item.plateType}</span>
          </div>
        </td>
      );
    } else if (
      field.toLowerCase() == "end" ||
      field.toLowerCase() == "start" ||
      field.toLowerCase().includes("date") ||
      isGeneratedAtField(field)
    ) {
      return <td key={fieldsIndex}>{
        value
        ? props.pageGrid == "gridVehicleActivities" ? toDateString(value) : toDateTime(value) 
        : ""}
        </td>;
    } else if (field.toLowerCase() == "ignition") {
      return (
        <td>
          <div
            style={{
              width: "20px",
              height: "20px",
              cursor: "help",
            }}
          >
            {item.ignition === "Ligado" ? (
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip id={`tooltip-location-${item.vehicleId}`}>
                    {item.ignition}
                  </Tooltip>
                }
              >
                <div
                  data-tooltip-id={`tooltip-${item.vehicleId}`}
                  data-tooltip-content="Ligado"
                >
                  <img
                    src="/images/icons/opened.png"
                    alt="Ligado"
                    style={{ width: "24px", marginLeft: "0px" }}
                  />
                </div>
              </OverlayTrigger>
            ) : item.ignition === "Desligado" ? (
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip id={`tooltip-location-${item.vehicleId}`}>
                    {item.ignition}
                  </Tooltip>
                }
              >
                <div
                  data-tooltip-id={`tooltip-${item.vehicleId}`}
                  data-tooltip-content="Desligado"
                >
                  <img
                    src="/images/icons/closed.png"
                    alt="Desligado"
                    style={{ width: "24px", marginLeft: "0px" }}
                  />
                </div>
              </OverlayTrigger>
            ) : (
              <div style={{ cursor: "default" }}>{item.ignition}</div>
            )}
          </div>
        </td>
      );
    } else if (
      field.toLowerCase().includes("speed") &&
      !field.toLowerCase().includes("count")
    ) {
      if (item.speedStatusDescription && item.speedStatusDescription !== "") {
        return (
          <td key={fieldsIndex}>
            <div class="tooltipReport">
              <span
                style={{
                  color: `${
                    item.speedStatus == "3" || item.speedStatus == "4"
                      ? "#FFA500"
                      : item.speedStatus != "0"
                      ? "#FF0000"
                      : "inherit"
                  }`,
                }}
              >
                {value ? toSpeedFormat(value) : "0.00 km/h"}
              </span>
              <span class="tooltipReportText">
                {item.speedStatusDescription}
              </span>
            </div>
          </td>
        );
      }
      return <td key={fieldsIndex}>{value ? toSpeedFormat(value) : "0.00 km/h"}</td>;
    } else if (
      field.toLowerCase().includes("distance") ||
      field.toLowerCase().includes("km")
    ) {
      return <td key={fieldsIndex}>{value ? toDistanceFormat(value) : ""}</td>;
    } else if (field.toLowerCase().includes("loca")) {
      return (
        <td key={fieldsIndex}>
          <a
            href={`https://maps.google.com/?q=${getLocationCoordinates(
              field,
              item
            )}`}
            target="_blank"
            rel="noreferrer"
            style={{
              cursor: "pointer",
              textDecoration: "underline",
              color: "inherit",
            }}
          >
            <div>{value}</div>
          </a>
        </td>
      );
    } else if (field.includes("statusDescription")) {
      return (
        <td key={fieldsIndex}>
          <div class="tooltipReport">
            <div
              style={{
                backgroundColor: `${item.statusColor}`,
                borderRadius: 5,
                width: 20,
                height: 20,
              }}
            />
            <span class="tooltipReportText">{item.statusDescription}</span>
          </div>
        </td>
      );
    } else if (field == "event") {
      return (
        <td key={fieldsIndex}>
          <div class="tooltipReport">
            <div
              style={{
                backgroundColor: `${
                  item.levelEvent == "1"
                    ? "#FF0000"
                    : item.levelEvent == "2"
                    ? "#FFA500"
                    : item.levelEvent == "3" && item.event !== ""
                    ? "#6495ED"
                    : "inherit"
                }`,
                borderRadius: 5,
                width: 20,
                height: 20,
              }}
            />
            <span class="tooltipReportText">{item.event}</span>
          </div>
        </td>
      );
    }
    return <td key={fieldsIndex}>{value}</td>;
  };

  const renderDataVertical = (value, item, field, fieldsIndex) => {
    
    if (!field) return;

    if (field.toLowerCase().includes("plate")) {
      return (
        <tr key={fieldsIndex}>
          <div class="tooltipReport">
            <span>{value} </span>
            <span class="tooltipReportText">{item.licensePlateType || item.plateType}</span>
          </div>
        </tr>
      );
    } else if (
      field.toLowerCase() == "end" ||
      field.toLowerCase() == "start" ||
      field.toLowerCase().includes("date") ||
      isGeneratedAtField(field)
    ) {
      return <tr key={fieldsIndex}>{value ? toDateTime(value) : ""}</tr>;
    } else if (field.toLowerCase() == "ignition") {
      return (
        <tr>
          <div
            style={{
              width: "20px",
              height: "20px",
              cursor: "help",
            }}
          >
            {item.ignition === "Ligado" ? (
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip id={`tooltip-location-${item.vehicleId}`}>
                    {item.ignition}
                  </Tooltip>
                }
              >
                <div
                  data-tooltip-id={`tooltip-${item.vehicleId}`}
                  data-tooltip-content="Ligado"
                >
                  <img
                    src="/images/icons/opened.png"
                    alt="Ligado"
                    style={{ width: "24px", marginLeft: "0px" }}
                  />
                </div>
              </OverlayTrigger>
            ) : item.ignition === "Desligado" ? (
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip id={`tooltip-location-${item.vehicleId}`}>
                    {item.ignition}
                  </Tooltip>
                }
              >
                <div
                  data-tooltip-id={`tooltip-${item.vehicleId}`}
                  data-tooltip-content="Desligado"
                >
                  <img
                    src="/images/icons/closed.png"
                    alt="Desligado"
                    style={{ width: "24px", marginLeft: "0px" }}
                  />
                </div>
              </OverlayTrigger>
            ) : (
              <div style={{ cursor: "default" }}>{item.ignition}</div>
            )}
          </div>
        </tr>
      );
    } else if (
      field.toLowerCase().includes("speed") &&
      !field.toLowerCase().includes("count")
    ) {
      if (item.speedStatusDescription && item.speedStatusDescription !== "") {
        return (
          <tr key={fieldsIndex}>
            <div class="tooltipReport">
              <span
                style={{
                  color: `${
                    item.speedStatus == "3" || item.speedStatus == "4"
                      ? "#FFA500"
                      : item.speedStatus != "0"
                      ? "#FF0000"
                      : "inherit"
                  }`,
                }}
              >
                {value ? toSpeedFormat(value) : ""}
              </span>
              <span class="tooltipReportText">
                {item.speedStatusDescription}
              </span>
            </div>
          </tr>
        );
      }
      return <tr key={fieldsIndex}>{value ? toSpeedFormat(value) : ""}</tr>;
    } else if (
      field.toLowerCase().includes("distance") ||
      field.toLowerCase().includes("km")
    ) {
      return <tr key={fieldsIndex}>{value ? toDistanceFormat(value) : ""}</tr>;
    } else if (field.toLowerCase().includes("loca")) {
      return (
        <tr key={fieldsIndex}>
          <a
            href={`https://maps.google.com/?q=${getLocationCoordinates(
              field,
              item
            )}`}
            target="_blank"
            rel="noreferrer"
            style={{
              cursor: "pointer",
              textDecoration: "underline",
              color: "inherit",
            }}
          >
            <div>{value}</div>
          </a>
        </tr>
      );
    } else if (field.includes("statusDescription")) {
      return (
        <tr key={fieldsIndex}>
          <div class="tooltipReport">
            <div
              style={{
                backgroundColor: `${item.statusColor}`,
                borderRadius: 5,
                width: 20,
                height: 20,
              }}
            />
            <span class="tooltipReportText">{item.statusDescription}</span>
          </div>
        </tr>
      );
    } else if (field == "event") {
      return (
        <tr key={fieldsIndex}>
          <div class="tooltipReport">
            <div
              style={{
                backgroundColor: `${
                  item.levelEvent == "1"
                    ? "#FF0000"
                    : item.levelEvent == "2"
                    ? "#FFA500"
                    : item.levelEvent == "3" && item.event !== ""
                    ? "#6495ED"
                    : "inherit"
                }`,
                borderRadius: 5,
                width: 20,
                height: 20,
              }}
            />
            <span class="tooltipReportText">{item.event}</span>
          </div>
        </tr>
      );
    }
    return <tr key={fieldsIndex}>{value}</tr>;
  };

  const getData = (data) => {
    if (Array.isArray(data)) {
      return data;
    } else if (Array.isArray(data.items)) {
      return data.items;
    } else if (Array.isArray(data.vehiclePositions)) {
      return data.vehiclePositions;
    } else return data;
  };

  const data = getData(props.gridData);

  return (
    <>
      <div className="card">
        <div className="table-responsive text-nowrap flipped">
          {data && Array.isArray(data) ? (
            <table className="table table-grid" id="paginated-table">
              <thead>
                <tr>
                  {columns.map((column, index) => (
                    <th key={index}>{column}</th>
                  ))}
                </tr>
              </thead>
              <tbody className="table-border-bottom-0">
                {data.map((item, index) => (
                  <tr key={index}>
                    {fields.map((field, fieldIndex) => (
                      <>{renderData(item[field], item, field, fieldIndex)}</>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <table className="table table-grid" id="paginated-table">
              {!data.error ? (
                <tbody className="table-border-bottom-0">
                  {fields.map((field, fieldIndex) => (
                    <tr>
                      <td>{columns[fieldIndex]}</td>
                      <td>
                        {renderDataVertical(
                          data[field],
                          data,
                          field,
                          fieldIndex
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              ) : (
                <tbody className="table-border-bottom-0">
                  <tr>
                    <td>{data.friendlyMessage ?? data.message}</td>
                  </tr>
                </tbody>
              )}
            </table>
          )}
        </div>
      </div>
    </>
  );
}
